import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

interface CardRatingProps {
	averageRating?: number | null;
	reviewCount?: number;
}

/** Stars and review count for a browse card; renders nothing without reviews. */
export function CardRating({ averageRating, reviewCount }: CardRatingProps) {
	const { t } = useTranslation();
	if (!reviewCount || reviewCount <= 0 || averageRating == null) {
		return null;
	}
	const rating = averageRating.toFixed(1);

	return (
		<span
			role="img"
			aria-label={t("cardRating.label", { rating, count: reviewCount })}
			className="flex items-center gap-1.5"
		>
			<Star
				aria-hidden="true"
				className="h-3.5 w-3.5 fill-dashboard-accent text-dashboard-accent"
			/>
			<span aria-hidden="true">
				{rating} ({reviewCount})
			</span>
		</span>
	);
}
